export const products = [
  {
    id: "001",
    title: "Relaxed Fit Pants",
    color: "white",
    price: 24.99,
    newArrival: true,
    iconImage: "mPants_1",
    images: ["mPants_1_p1", "mPants_1_p2", "mPants_1_p3", "mPants_1_p4"],
    type: "men's pants",
    colors: 3,
    colorPhotos: [
      { id: 1, color: "white", photo: "mPants_1_c1" },
      { id: 2, color: "tan", photo: "mPants_1_c2" },
      { id: 3, color: "blue", photo: "mPants_1_c3" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "m",
    url: 'relaxed-fit-pants'
  },
  {
    id: "002",
    title: "Knee-length Dress",
    color: "sky blue",
    price: 39.99,
    newArrival: false,
    iconImage: "wDress_1",
    images: ["wDress_1_p1", "wDress_1_p2", "wDress_1_p3"],
    type: "women's dress",
    colors: 1,
    colorPhotos: [{ id: 1, color: "sky blue", photo: "wDress_1_c1" }],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'knee-length-dress',
  },
  {
    id: "003",
    title: "Slides",
    color: "black",
    price: 19.99,
    newArrival: false,
    iconImage: "wShoes_2",
    images: ["wShoes_2_p1", "wShoes_2_p2"],
    type: "women's shoes",
    colors: 1,
    colorPhotos: [{ id: 1, color: "black", photo: "wShoes_2_c1" }],
    lrgImg: false,
    qty: 1,
    gender: "w",
    url: 'slides',
  },
  {
    id: "004",
    title: "Cotton-blend",
    color: "Pink",
    price: 24.99,
    newArrival: true,
    iconImage: "wSweats_1",
    images: ["wSweats_1_p1", "wSweats_1_p2"],
    type: "women's sweatpants",
    colors: 3,
    colorPhotos: [
      { id: 1, color: "pink", photo: "wSweats_1_c1" },
      { id: 2, color: "gray", photo: "wSweats_1_c2" },
      { id: 3, color: "black", photo: "wSweats_1_c3" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'cotton-blend',
  },
  {
    id: "005",
    title: "Relaxed-fit Hoodie",
    color: "Dark Green",
    price: 29.99,
    newArrival: false,
    iconImage: "mTop_2",
    images: ["mTop_2_p1", "mTop_2_p2", "mTop_2_p3", "mTop_2_p4"],
    type: "men's shirt",
    colors: 3,
    colorPhotos: [
      { id: 1, color: "Dark Green", photo: "mTop_2_c1" },
      { id: 2, color: "Brown", photo: "mTop_2_c2" },
      { id: 3, color: "Tan", photo: "mTop_2_c3" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "m",
    url: 'relaxed-fit-hoodie',
  },
  {
    id: "006",
    title: "Ribbed Tank Top",
    color: "Burgundy",
    price: 19.99,
    newArrival: false,
    iconImage: "wTop_1",
    images: ["wTop_1_p1", "wTop_1_p2", "wTop_1_p3"],
    type: "women's top",
    colors: 5,
    colorPhotos: [
      { id: 1, color: "Burgundy", photo: "wTop_1_c1" },
      { id: 2, color: "white", photo: "wTop_1_c2" },
      { id: 3, color: "blue", photo: "wTop_1_c3" },
      { id: 4, color: "lavender", photo: "wTop_1_c4" },
      { id: 5, color: "pink", photo: "wTop_1_c5" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'ribbed-tank-top',
  },
  {
    id: "007",
    title: "Long Fit T-shirt",
    color: "black",
    price: 44.99,
    newArrival: false,
    iconImage: "mTop_3",
    images: ["mTop_3_p1", "mTop_3_p2"],
    type: "men's shirt",
    colors: 4,
    colorPhotos: [
      { id: 1, color: "black", photo: "mTop_3_c1" },
      { id: 2, color: "orange", photo: "mTop_3_c2" },
      { id: 3, color: "blue", photo: "mTop_3_c3" },
      { id: 4, color: "beige", photo: "mTop_3_c4" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "m",
    url: 'long-fit-t-shirt',
  },
  {
    id: "008",
    title: "Ribbed Henley Shirt",
    color: "Dark Taupe",
    price: 29.99,
    newArrival: false,
    iconImage: "wTop_2",
    images: ["wTop_2_p1", "wTop_2_p2", "wTop_2_p3"],
    type: "women's top",
    colors: 3,
    colorPhotos: [
      { id: 1, color: "Dark Taupe", photo: "wTop_2_c1" },
      { id: 2, color: "white", photo: "wTop_2_c2" },
      { id: 3, color: "pink", photo: "wTop_2_c3" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'ribbed-henley-shirt',
  },
  {
    id: "009",
    title: "Corduroy Shirt",
    color: "Heather purple",
    price: 49.99,
    newArrival: false,
    iconImage: "mTop_1",
    images: ["mTop_1_p1", "mTop_1_p2", "mTop_1_p3"],
    type: "men's shirt",
    colors: 3,
    colorPhotos: [
      { id: 1, color: "Heather Purple", photo: "mTop_1_c1" },
      { id: 2, color: "light brown", photo: "mTop_1_c2" },
      { id: 3, color: "dark blue", photo: "mTop_1_c3" },
    ],
    lrgImg: true,
    qty: 1,
    gender: "m",
    url: 'corduroy-shirt',
  },
  {
    id: "010",
    title: "High Ankle Jeans",
    color: "Denim Blue",
    price: 49.99,
    newArrival: false,
    iconImage: "wPants_1",
    images: ["wPants_1_p1", "wPants_1_p2", "wPants_1_p3", "wPants_1_p4"],
    type: "women's pants",
    colors: 1,
    colorPhotos: [{ id: 1, color: "denim blue", photo: "wPants_1_c1" }],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'high-ankle-jeans',
  },
  {
    id: "011",
    title: "printed sweatshirt",
    color: "Pink Blue",
    price: 29.99,
    newArrival: true,
    iconImage: "wTop_3",
    images: ["wTop_3_p1", "wTop_3_p2", "wTop_3_p3"],
    type: "women's top",
    colors: 1,
    colorPhotos: [{ id: 1, color: "pink blue", photo: "wTop_3_c1" }],
    lrgImg: true,
    qty: 1,
    gender: "w",
    url: 'printed-sweatshirt',
  },
  {
    id: "012",
    title: "Chelsea Boots",
    color: "Black",
    price: 124.99,
    newArrival: false,
    iconImage: "wShoes_1",
    images: ["wShoes_1_p1", "wShoes_1_p2"],
    type: "women's shoes",
    colors: 2,
    colorPhotos: [
      { id: 1, color: "black", photo: "wShoes_1_c1" },
      { id: 2, color: "brown", photo: "wShoes_1_c2" },
    ],
    lrgImg: false,
    qty: 1,
    gender: "w",
    url: 'chelsea-boots',
  },
  {
    id: "013",
    title: "pleated skirt",
    color: "midnight black",
    price: 24.99,
    newArrival: true,
    iconImage: "wSkirt_1",
    images: ["wSkirt_1_p1", "wSkirt_1_p2", "wSkirt_1_p3", "wSkirt_1_p4"],
    type: "women's skirt",
    colors: 1,
    colorPhotos: [{ id: 1, color: "midnight black", photo: "wSkirt_1_c1" }],
    lrgImg: false,
    qty: 1,
    gender: "w",
    url: 'pleated-skirt',
  },
  {
    id: "014",
    title: "chelsea boots",
    color: "light beige",
    price: 124.99,
    newArrival: true,
    iconImage: "mShoes_1",
    images: ["mShoes_1_p1", "mShoes_1_p2"],
    type: "men's shoes",
    colors: 2,
    colorPhotos: [
      { id: 1, color: "light beige", photo: "mShoes_1_c1" },
      { id: 2, color: "dark brown", photo: "mShoes_1_c2" },
    ],
    lrgImg: false,
    qty: 1,
    gender: "m",
    url: 'chelsea-boots',
  },
  {
    id: "015",
    title: "Regular Fit Sweatshorts",
    color: "pink",
    price: 29.99,
    newArrival: false,
    iconImage: "mShorts_1",
    images: ["mShorts_1_p1", "mShorts_1_p2", "mShorts_1_p3"],
    type: "men's shorts",
    colors: 3,
    colorPhotos: [
      {id: 1, color: 'pink', photo: 'mShorts_1_c1'},
      {id: 1, color: 'gray', photo: 'mShorts_1_c2'},
      {id: 1, color: 'black', photo: 'mShorts_1_c3'},
  ],
    lrgImg: false,
    qty: 1,
    gender: "m",
    url: 'regular-fit-sweatshorts',
  },
];

export default products;
